module.exports = __webpack_public_path__ + "img/v10.3845dff6.png";